module.exports = __webpack_public_path__ + "img/gaoya.74373ba1.png";